import { Domain } from '../types';
import { SelectedDomainsForNewEmailAccounts } from '../../email-accounts/types/create-email-infrastructure';

export const formatDomainsData = (
  domain: Domain,
): SelectedDomainsForNewEmailAccounts => ({
  id: domain.id,
  name: domain.name,
  emailServiceProvider: domain.order.emailServiceProvider,
  isMultipleDomains: false,
  domains: [
    {
      id: domain.id,
      name: domain.name,
      status: domain.status,
      orderId: domain.order.id,
      mailboxes: domain.mailboxes.map((m) => ({ id: m.id, email: m.email })),
    },
  ],
});
